import { createContext, useContext, useEffect } from "react";

export interface NavCollapseContextValue {
  /**
   * Requests that the left nav stay collapsed. Returns a function that releases
   * the request. Stable across renders so callers can register it in an effect.
   */
  requestTemporaryCollapse: () => () => void;
}

export const NavCollapseContext = createContext<NavCollapseContextValue | null>(
  null,
);

/**
 * While the calling component is mounted, requests that the app's left nav be
 * temporarily collapsed (e.g. on full-width editor pages). The nav returns to
 * its previous state once the component unmounts. No-op outside the app layout.
 */
export function useCollapseNavWhileMounted(): void {
  const context = useContext(NavCollapseContext);

  useEffect(() => {
    return context?.requestTemporaryCollapse();
  }, [context]);
}
